<script lang="ts">
	//Design system components
	import { Text } from '@Shelly/shelly-design-system';
	//Components
	import RollerSlider from '../SchedulesHelpers/RollerSlider.svelte';
	//Services
	import { format } from 'svelte-i18n';
	//Svelte hooks
	import { createEventDispatcher, getContext } from 'svelte';

	export let disabled;
	const scheduleStore: SvelteStore<any> = getContext('schedule');
	let rollerHeight = $scheduleStore.rollerHeight;

	$: switch ($scheduleStore.rollerHeight) {
		case '101':
			rollerHeight = 0;
			break;

		default:
			break;
	}
	const dispatch = createEventDispatcher();
	const changeHeight = (e) => {
		dispatch('update', { rollerHeight: e.detail });
	};
</script>

<Text class="mb-l" element="h2">
	{$format('select_type', {
		values: { type: $format('roller_position') },
	})}
</Text>
<RollerSlider
	{disabled}
	title={$format('roller_position')}
	value={rollerHeight}
	on:change={changeHeight}
/>
